import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    data: {},
    emptyDeliveryAddress: false,
    changeDeliveryAddress: true,
    progressBarId: null,
    hideDeliveryAddress: false,
    showShippingCountdown: false,
    pickupExpressEnterPhoneEnabled: true,
    showCustomErrorMessage: false,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.SET_STORED_ADDRESS:
            return { ...state, registeredUser: action.payload };
        case types.SELECT_STORE:
            return {
                ...state,
                data: {
                    ...state.data,
                    selectedStore: action.payload.id,
                },
            };
        case types.SHIPPING_BLOCKED:
            return {
                ...state,
                data: {
                    ...state.data,
                    shippingBlocked: action.payload,
                },
            };
        case types.SET_DELIVERY_MODE:
            return {
                ...state,
                data: {
                    ...state.data,
                    deliveryMode: action.payload,
                },
            };
        case types.CLEAR_DELIVERY_MODE:
            return {
                ...state,
                data: {
                    ...state.data,
                    deliveryMode: 'none',
                },
            };
        case types.CLEAR_DELIVERY_MODE_ON_PAYMENT_STEP:
            return {
                ...state,
                data: {
                    ...state.data,
                    deliveryMode: 'none',
                    previousDeliveryMode: state.data.deliveryMode,
                },
            };
        case types.SET_CHANGE_DELIVERY_ADDRESS:
            return reduceAction(state, 'changeDeliveryAddress', !!action.payload.status);

        case types.SET_ADDRESS_FOR_BILLING: {
            return {
                ...state,
                data: {
                    ...state.data,
                    addressForBilling: action.payload,
                },
            };
        }
        case types.SET_USE_DELIVERY_AS_BILLING: {
            return {
                ...state,
                data: {
                    ...state.data,
                    useDeliveryAsBilling: action.payload.value || false,
                },
            };
        }
        case types.EMPTY_DELIVERY_ADDRESS:
            return reduceAction(state, 'emptyDeliveryAddress', action.payload);

        case types.SET_PROGRESS_BAR_ID:
            return {
                ...state,
                progressBarId: action.payload.progressBarId,
                hideDeliveryAddress: false,
            };
        case types.HIDE_DELIVERY_ADDRESS:
            return reduceAction(state, 'hideDeliveryAddress', action.payload);

        case types.SHOW_SHIPPING_COUNTDOWN:
            return reduceAction(state, 'showShippingCountdown', true);

        case types.HIDE_SHIPPING_COUNTDOWN:
            return reduceAction(state, 'showShippingCountdown', false);

        case types.DISABLE_PICKUP_EXPRESS_ENTER_PHONE:
            return reduceAction(state, 'pickupExpressEnterPhoneEnabled', false);

        case types.ENABLE_PICKUP_EXPRESS_ENTER_PHONE:
            return reduceAction(state, 'pickupExpressEnterPhoneEnabled', true);

        case types.SHOW_CUSTOM_ERROR_MESSAGE:
            return { ...state, showCustomErrorMessage: action.payload };

        default:
            return state;
    }
};

export default reducers;
